var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBwInstagram = function SvgBwInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9E9",
    d: "M7.29 0C3.27 0 0 3.272 0 7.293v10.416C0 21.729 3.272 25 7.293 25h10.416C21.729 25 25 21.727 25 17.707V7.29C25 3.27 21.727 0 17.707 0zM20 4a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-7.5 2c3.585 0 6.5 2.915 6.5 6.5S16.084 19 12.5 19A6.507 6.507 0 0 1 6 12.5C6 8.915 8.915 6 12.5 6m0 2a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9"
  })));
};
export default SvgBwInstagram;